import { produce } from 'immer';

import { wrapReducers } from '~/state/lib';
import INIT_STATE from './state';

const reducer = {
  changePlacement: produce((draft, id) => {
    switch (id) {
      case 'instagram-feed': {
        draft.placements.set('instagram-feed', true);
        draft.placements.set('instagram-story', false);
        break;
      }
      case 'instagram-story': {
        draft.placements.set('instagram-feed', false);
        draft.placements.set('instagram-story', true);
        break;
      }
      default: {
        const valueToToggle = draft.placements.get(id);
        draft.placements.set(id, !valueToToggle);
      }
    }
  }),
  changeInstagramPlacement: produce((draft) => {
    draft.instagramSelected = !draft.instagramSelected;

    if (draft.instagramSelected) {
      draft.placements.set('instagram-story', true);
      draft.instagramSelected = true;
    } else {
      draft.placements.set('instagram-feed', false);
      draft.placements.set('instagram-story', false);
    }
  }),
  enableLeadAd: produce((draft) => {
    draft.placements.set('mobile-external', false);
    draft.placements.set('right-column', false);
  }),
  disableLeadAd: produce((draft) => {
    draft.placements.set('mobile-external', true);
    draft.placements.set('right-column', true);
  }),
};

export default wrapReducers(reducer, INIT_STATE);
